// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__asxVm","buttons":"Footer_buttons__3k-Md"};